import { render, staticRenderFns } from "./customer-layout.vue?vue&type=template&id=148d52cc"
import script from "./customer-layout.vue?vue&type=script&lang=js"
export * from "./customer-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports